import { render, staticRenderFns } from "./AppEditorBlock.vue?vue&type=template&id=5600a45c"
import script from "./AppEditorBlock.vue?vue&type=script&lang=js"
export * from "./AppEditorBlock.vue?vue&type=script&lang=js"
import style0 from "./AppEditorBlock.vue?vue&type=style&index=0&id=5600a45c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports